import { render, staticRenderFns } from "./joinActivityActivityDetail.vue?vue&type=template&id=17e47cde&scoped=true"
import script from "./joinActivityActivityDetail.vue?vue&type=script&lang=js"
export * from "./joinActivityActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./joinActivityActivityDetail.vue?vue&type=style&index=0&id=17e47cde&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e47cde",
  null
  
)

export default component.exports